import React from 'react';

import {ReactComponent as DownloadIcon} from 'shared/assets/download.svg';
import {IAttachment} from 'shared/types/files';
import {downloadFileById} from 'shared/utils/file';

import 'components/form/fields/download-document-list-item/download-document-list-item.less';

export interface IDownloadDocumentListItemProps {
    fileList: IAttachment[] | undefined;
    entityName: string;
    isDownloadDisabled?: boolean;
}

export const DownloadDocumentListItem = ({
    fileList, entityName, isDownloadDisabled,
}: IDownloadDocumentListItemProps) => (
    fileList ? (
        <>
            {fileList.map(file => (
                <div className="download-document-list-item">
                    <span>{file.fileName || '-'}</span>
                    {file && file.fileName && file.attachmentId && !isDownloadDisabled
                        && (
                            <DownloadIcon
                                onClick={() => downloadFileById(
                                    file.fileName,
                                    file.attachmentId,
                                    entityName,
                                )}
                            />
                        )}
                </div>
            ))}
        </>
    ) : <span>-</span>
);
